import { render, staticRenderFns } from "./JoinFormComponent.vue?vue&type=template&id=d7fcf608&scoped=true&"
import script from "./JoinFormComponent.vue?vue&type=script&lang=js&"
export * from "./JoinFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./JoinFormComponent.vue?vue&type=style&index=0&id=d7fcf608&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7fcf608",
  null
  
)

export default component.exports